import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import { useAxios } from "../../hooks";
import { PageHeader, Pagination } from "../../components";
import List from "./template list component/Table";
import { PrimaryButton } from "../css components/Button";

export default function TemplateList() {
  const navigate = useNavigate();
  const { agent, accessToken } = useSelector((state) => state.memberDetails);

  const axios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: "Bearer " + accessToken,
  });

  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastPage: false,
  });
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [sortBy, setSortBy] = useState(agent[0].agent_id);

  useEffect(() => {
    if (sortBy) {
      setLoading(true);

      axios({
        url: "/template/" + sortBy + "?page=" + page.page + "&skip=10",
      }).then((response) => {
        if (response.status) {
          setTemplates(response.data.temp_obj);
          setPage((prev) => ({
            ...prev,
            totalCount: response.data?.total_template,
            lastPage: response.data.temp_obj?.length < 10,
          }));
          setLoading(false);
        } else {
          setTemplates([]);

          setPage((prev) => ({
            ...prev,
            totalCount: response.data?.total_template,
            lastPage: response.data.temp_obj?.length < 10,
          }));
          setLoading(false);
        }
      });
    }
  }, [axios, page.page, sortBy]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev.page + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"My Templates"}
            pageHeader="List of Templates"
            buttons={[
              <PrimaryButton
                onClick={() =>
                  navigate(pages.createTemplate.route + "?agent_id=" + sortBy)
                }
                variant="contained"
              >
                Add Template
              </PrimaryButton>,
            ]}
          />
        </Grid>
      </Grid>

      <List
        agent={agent}
        loading={loading}
        templates={templates}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
